import {createActions} from 'client/framework';

export default createActions(null, [
  'SUBMIT_FEEDBACK',
  'UPDATE_QUESTION',
  'UPDATE_FEEDBACK_MESSAGE',
  'CLEAR_TOAST'
]);
